import React from 'react';
import { Button } from '@clearcover/atlas';
import { Asset, CheckmarkIcon } from '@clearcover/atlas';
import { stringToBoolean } from 'Shared/utils';
import { getDisplayValue } from 'QuoteApp/components/ReportDetails/ReportDetailRow';
import styles from './styles.module.css';

type LicenseVerifiedProps = {
  isEditing: boolean;
  formLicenseVerified: string;
  driverLicenseVerified: string;
  onChange: (value: string) => void;
};

const LicenseVerified = ({
  isEditing,
  formLicenseVerified,
  driverLicenseVerified,
  onChange,
}: LicenseVerifiedProps) => {
  const formLicenseVerifiedBool = stringToBoolean(formLicenseVerified);
  const driverLicenseVerifiedBool = stringToBoolean(driverLicenseVerified);

  switch (true) {
    case isEditing && !formLicenseVerifiedBool && !driverLicenseVerifiedBool:
      return (
        <Button
          type="button"
          size="sm"
          variant="secondary"
          onClick={() => onChange('true')}
          data-testid="verify-license"
          className={styles.licenseVerifiedStatusWrapper}
        >
          <Asset
            icon={CheckmarkIcon}
            height={16}
            width={16}
            description="Verify License Check Icon"
            className={styles.licenseVerifyCheckIcon}
          />
          Verify
        </Button>
      );
    case isEditing && formLicenseVerifiedBool:
      return (
        <div className={styles.licenseVerifiedStatusWrapper}>
          <Asset
            icon={CheckmarkIcon}
            height={16}
            width={16}
            description="License Verified Check Icon"
            className={styles.licenseVerifiedCheckIcon}
          />
          <span className={styles.licenseVerifiedStatusText}>Verified</span>
        </div>
      );
    default:
      return <span>{getDisplayValue(driverLicenseVerified) || '—'}</span>;
  }
};

export default LicenseVerified;
